<template>
    <div>
        <el-dialog :before-close="closeModal" :visible.sync="$store.state['zsm-pay'].payModalWarnFlag" class="pay-warn" top="12vh" width="520px">
            <div slot="title">
                <div class="flex flex-align-center">
                    <i class="el-icon-warning"></i>
                    <span class="tit font-size-lg">升级版本  解锁服务</span>
                </div>
            </div>
            <div>
                <div>当前版本为： <span class="blue">多端综合版本</span></div>
                <div>
                    到期时间：<span v-if="accountInfo"> {{accountInfo.expireDateStr}}</span>
                </div>
                <div class="desc font-size-base">
                    当前服务已到期， 请前往订阅后继续使用该服务
                </div>
                <div class="btn_list flex">
                    <el-button @click="closeModal">取消</el-button>
                    <el-button @click="serviceModal=true">联系商务</el-button>
                    <el-button type="primary" @click="$router.replace('/pay');$store.state['zsm-pay'].payModalWarnFlag=false">立即订阅</el-button>
                </div>
            </div>
            <el-dialog class="enroll" :show-close="false" center style="box-shadow: 0px 2px 6px 0px rgba(#c0bebe, 0.61);" :visible.sync="serviceModal" append-to-body top="12vh" width="400px">
                <!-- 联系客服页 -->
                <div class="enrollForm agent">
                    <div class="top font-size-lg">联系商务</div>
                    <div>
                        <div class="agentUser">
                            <img :src="authority.wechatQaCode" />
                        </div>
                    </div>
                </div>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        props: ['accountInfo'],
        data() {
            return {
                authority: '', //默认销售
                serviceModal: false
            }
        },
        mounted() {
            this.getAuthority()
        },
        methods: {
            // 获取默认销售人员
            async getAuthority() {
                let res = await this.$store.dispatch('zsm-user/getAuthority');
                this.authority = res;
            },
            // 关闭弹框
            closeModal() {
                this.$router.replace('/user');
                this.$store.state['zsm-pay'].payModalWarnFlag = false
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../style/warn.scss";
</style>
